import { MODALITIES } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse, Institution, User } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';
import { TEMPLATE_TYPE } from '../constants/report.constant';

const TEMPLATE_URL = '/ris/templates/v1';

export interface ParamsGetTemplates {
  code?: string;
  institution_ids?: string[];
  limit?: number;
  name?: string;
  offset?: number;
  procedure_ids?: string[];
  sort_field?: '' | 'code' | 'name' | 'procedure_id' | 'user_id';
  sort_order?: SORT_ORDER;
  status?: TEMPLATE_TYPE;
  updated_at_from?: string;
  updated_at_to?: string;
  user_ids?: string[];
}
export interface ResponseGetTemplate extends DefaultResponse {
  data: {
    id: string;
    institution_id: string;
    user_id: string;
    procedure_id: null | string;
    layout_id: null | string;
    code: string;
    name: string;
    content: string;
    conclusion: string;
    status: number;
    created_at: Date;
    updated_at: Date;
    institution: Institution;
    user: Omit<
      User,
      'expired_at' | 'institutions' | 'roles' | 'scopes' | 'signature'
    >;
    procedure: null | {
      id: string;
      institution_id: string;
      user_id: string;
      code: string;
      name: string;
      compact_name: string;
      modality: MODALITIES;
      procedure_group_id: null | string;
      active: boolean;
      created_at: Date;
      updated_at: Date;
      institution: null | unknown;
      user: null | unknown;
      procedure_group: null | unknown;
    };
    layout: null | {
      id: string;
      institution_id: string;
      user_id: string;
      name: string;
      status: number;
      content: string;
      active: boolean;
      created_at: Date;
      updated_at: Date;
      institution: null | unknown;
      user: null | unknown;
    };
  };
}
export interface ResponseGetTemplates extends DefaultResponse {
  data: ResponseGetTemplate['data'][];
}
export const getTemplates = async (params: ParamsGetTemplates = {}) => {
  const response = (await api({
    url: TEMPLATE_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetTemplates>;

  return response.data;
};

export const getTemplate = async (id: string) => {
  const response = (await api({
    url: TEMPLATE_URL + '/' + id,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetTemplate>;

  return response.data;
};

export interface ParamsCreateTemplate {
  code: string;
  conclusion: string;
  content: string;
  institution_id: string;
  name: string;
  procedure_id: string;
  status: TEMPLATE_TYPE;
}
export const createTemplate = async (data: ParamsCreateTemplate) => {
  const response = (await api({
    url: TEMPLATE_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateTemplate {
  code: string;
  conclusion: string;
  content: string;
  name: string;
  procedure_id: string;
  status: number;
}
export const updateTemplate = async (
  id: string,
  data: ParamsUpdateTemplate
) => {
  const response = (await api({
    url: `${TEMPLATE_URL}/${id}`,
    method: 'PATCH',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteTemplate = async (id: string) => {
  const response = (await api({
    url: `${TEMPLATE_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};
